<template>
  <el-image
    v-if="logoUrl"
    style="width: 200px; height: inherit;"
    :src="logoUrl"
    fit="scale-down"
  />
  <template v-else>
    <LogoHubstr />
  </template>
</template>

<script lang="ts">
import {
  defineComponent, onMounted, ref, watch,
} from 'vue';
import LogoHubstr from 'assets/hubstr/icons/logo-not-collapsed.svg';
import useStore from '~/store/useStore';

export default defineComponent({
  name: 'LogoNotCollapsed',
  components: { LogoHubstr },
  setup () {
    const store = useStore();
    const logoUrl = ref('');
    const local = JSON.parse(localStorage.getItem('magner-hubstr') as string);

    onMounted(() => {
      if (local.logo) {
        logoUrl.value = local.logo.upload_down_scale;
      }
    });

    watch(() => store.defaultLogo, () => {
      logoUrl.value = store.defaultLogo?.value.upload_down_scale;
    }, { deep: true });

    return {
      local,
      logoUrl,
    };
  },
});
</script>

<style scoped>

</style>
